import { TrelloMarkdownWrapper } from './TrelloMarkdownWrapper';

export type MarkdownContentType =
  | 'bio'
  | 'checkitems'
  | 'comment'
  | 'description';

// eslint-disable-next-line @trello/no-module-logic
export const markdown = new TrelloMarkdownWrapper();
